module.exports = __webpack_public_path__ + "img/icon-pending.05b0e014.svg";